import { api } from "./http";

const authApi = {
  login: (email, password) =>
    api.post("/auth/login", { email, password }),
  me: () => api.get("/auth/me"),

  changePassword: (oldPassword, newPassword) =>
    api.post("/auth/change-password", { oldPassword, newPassword }),

  forgotPassword: (email) =>
    api.post("/auth/forgot-password", { email }),

  resetPassword: (email, code, newPassword) =>
    api.post("/auth/reset-password", { email, code, newPassword }),
  register: (param) => api.post("/auth/register", param)
};

export default authApi;
